export default {
  namespaced: true,
  state: {
    packageVersion: process.env.VUE_APP_VERSION || '0',
  },

  getters: {
    appVersion: (state) => state.packageVersion,
  },

  actions: {},

  mutations: {},
}
